import { render, staticRenderFns } from "./CoinChart.vue?vue&type=template&id=258f0f47&scoped=true"
import script from "./CoinChart.vue?vue&type=script&lang=js"
export * from "./CoinChart.vue?vue&type=script&lang=js"
import style0 from "./CoinChart.vue?vue&type=style&index=0&id=258f0f47&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "258f0f47",
  null
  
)

export default component.exports